import {createRoot} from 'react-dom/client'
// import App from './App'
import { Provider } from 'react-redux'
import { store } from './app/store'
import { Suspense, lazy } from 'react'
import { ParallaxProvider } from 'react-scroll-parallax';
import Splash from './components/Splash'

const App=lazy(()=>delayForDemo(import('./App')))
function delayForDemo(promise) {
    return new Promise(resolve => {
        setTimeout(resolve, 2000);
    }).then(() => promise);
}
createRoot(document.getElementById('root')).render(
<Suspense fallback={<Splash />}>
    <Provider store={store}>
        <ParallaxProvider>
            <App/>
        </ParallaxProvider>
    </Provider>
</Suspense>)